var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9302 6.09046C13.1513 -0.0848411 4.84899 -0.0848411 2.07011 6.09046C1.92846 6.40524 1.55845 6.54558 1.24368 6.40393C0.928901 6.26229 0.788555 5.89228 0.930203 5.57751C4.15132 -1.58052 13.849 -1.58052 17.0701 5.57751C17.2118 5.89228 17.0714 6.26229 16.7566 6.40393C16.4419 6.54558 16.0719 6.40524 15.9302 6.09046Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00015 4.79232C10.0357 4.79232 10.8752 5.63178 10.8752 6.66732C10.8752 7.70285 10.0357 8.54232 9.00015 8.54232C7.96462 8.54232 7.12515 7.70285 7.12515 6.66732C7.12515 5.63178 7.96462 4.79232 9.00015 4.79232ZM12.1252 6.66732C12.1252 4.94143 10.726 3.54232 9.00015 3.54232C7.27426 3.54232 5.87515 4.94143 5.87515 6.66732C5.87515 8.39321 7.27426 9.79232 9.00015 9.79232C10.726 9.79232 12.1252 8.39321 12.1252 6.66732Z",
    fill: "#656579"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpned);
export default __webpack_public_path__ + "static/media/eye_opned.beaf49e8b51754c53e48451c7f25a0d9.svg";
export { ForwardRef as ReactComponent };